import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import CardLessDataTableWithOutSearch from '../../datatables/CardLessDataTableWithOutSearch';
import '../_feeStructure.scss'


class StudentsModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defaultvalue: 0,
        }
    }


    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({ dataClear: 1 })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    Columns(data) {
        let Columns = [
            {
                dataField: "student_name",
                text: "Student Name",
            },
            {
                dataField: "pending_amount",
                text: "Pending Amount",
                sort: true
            },
            {
                dataField: "due_amount",
                text: "Due Amount",
                sort: true
            },
        ];
        return Columns;
    }

    ColumnsDue(data) {
        let Columns = [
            {
                dataField: "student_name",
                text: "Student Name",
            },
            {
                dataField: "due_amount",
                text: "Due Amount",
                sort: true
            },
        ];
        return Columns;
    }

    tableData(data) {
        let array = [];
        data.map((item) => {
            const newobj = {   
                student_name: item.student_name,
                pending_amount: item.pending_amount != undefined ? item.pending_amount.toLocaleString('en-IN') : "",
                parent_mobile: item.parent_mobile,
                due_amount: item.due_amount.toLocaleString('en-In')
            }
            array.push(newobj)
        })
        return array
    }

    render() {
        return (
            <Modal {...this.props} size="md"  aria-labelledby="example-modal-sizes-title-lg" >
                <Modal.Header closeButton>
                    <Modal.Title>Students Data</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <CardLessDataTableWithOutSearch
                        parentData={this.tableData(this.props.studentsFeeData)}
                        particlecolumns={this.props.tableType == "due" ? this.ColumnsDue() : this.Columns()}
                    />
                </Modal.Body>
            </Modal >
        );
    }
}

export default (StudentsModal);
